import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import FoxTrader from "./../../../Images/foxtrader.png";
import "./TradeTronDownload.css";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';

function TradeTronDownload() {
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

           // console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://tradetron.tech/html-view/Configure-Moneysukh',
                '_blank' // <- This is what makes it open in a new window.
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
  return (
    <>
      <section className="fox-download">
        <Container>
          <Row>
            <Col md={5}>
              <div className="fox-download-img">
                <img className="img-fluid" src={FoxTrader} alt="FoxTrader" />
              </div>
            </Col>
            <Col md={7}>
              <div>
                <h3>Trade Tron</h3>
                <p>
                Tradetron is a Web-based, Android, and iOS application. To begin using it, download and install the application 
                on your preferred device. Set up your account by filling all the required information and submit the form. 
                After successful authentication, Trade Tron is ready for usage.
                </p>
                          </div>
                          <div>
                              <button type="button" onClick={() => clickToggleLoginPopup(true)}  className="Login-Button-fox w-50 startnow_btn end-0">
                                   Get Started
                              </button>
                          </div>  
            </Col>
                  </Row>
                  <LoginPopup show={show} ref={childRef} />
              </Container>

      </section>
    </>
  );
}
export default TradeTronDownload;
